import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: '',
  remarks: '',
  filePath: '',
  isNew: true,
  fullUrl: '',
});
const UpdateUnitMaster = () => {
  const apiService = new LeaseApiService();
  let navigate = useNavigate();
  const userName = useSelector(getName);
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false]);
  const [loading, setloader] = useState(false);
  // Master Listings
  const [measurementList, setMeasurementList] = useState([]);
  const [salersList, setSalesPersonList] = useState([]);
  const [bedRoomList, setBedRoomList] = useState([]);
  const [landlordList, setLandlordList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [communityList, setcommunityList] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitViewList, setunitViewList] = useState([]);
  const [imageView, setImageView] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [cityList, setCityList] = useState([]);
  // Unit Listings
  const [manDateList, setManDateList] = useState([]);
  const [reserveAccList, setReserveAccList] = useState([]);
  const [keyStatusList, setKeyStatusList] = useState([]);
  const [unitCostList, setUnitCostList] = useState([]);
  const [paymentPlan, setPaymentPlan] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [costAccount, setCostAccount] = useState([]);
  const [agent, setAgent] = useState([]);
  const [furnishing, setFurnishing] = useState([]);
  const [refferedBy, setRefferedBy] = useState([]);
  const [enteredBy, setEnteredBy] = useState([]);
  const [furniturePlan, setFurniturePlan] = useState([]);
  const [period, setPeriod] = useState([]);
  const [sizeType, setSizeType] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [currencyList, setCurrency] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const location = useLocation();
  const leaseData = location.state;
  const [unitAudit, setUnitAudit] = useState({ createdBy: '0', createdOn: null });
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
  const formatDate = (date) => {
    return moment(date).format('DD-MMM-YYYY');
  };

  const [transectionData, setTransectionData] = useState({
    saller: null,
    landlordId: null,
    property: null,
    community: null,
    unitType: null,
    unitCategory: null,
    country: null,
    city: null,
    unitView: null,
    floor: null,
    bedRooms: null,
    unitNo: '',
    contactPerson: '',
    municipltyNo: '',
    refNo: '',
    unitClass: '',
    sector: '',
    block: '',
    bathRoom: '',
    balcony: '',
    livingarea: '',
    terraceArea: '',
    totalArea: '',
    parking: '',
    unitRate: '',
    remarks: '',
    parkingPrice: '',
    resale: false,
  });
  const [unitDetails, setUnitDetails] = useState({
    mandate: null,
    reservedAccCode: null,
    statusKey: null,
    unitCost: null,
    paymentPlan: null,
    status: null,
    costAccount: null,
    agent: null,
    furnishing: null,
    refferedBy: null,
    enteredBy: '0',
    furniturePlan: null,
    unitModel: '',
    serviceCharge: '',
    unitStyle: '',
    reservedFund: '',
    storeRoom: '',
    plotNO: '',
    company: '',
    financeOffered: '',
    plotSize: '',
    additionalWorkCost: '',
    streetNo: '',
    opt2Cost: '',
    opt3Cost: '',
    furnitureCost: '',
    occupied: false,
    propertyRegistered: false,
    leased: false,
    completionDate: '',
    expiryDate: formattedDate,
    reffferedDate: formattedDate,
    enteredDate: formattedDate,
    modifiedDate: formattedDate,
  });
  const [salesDetails, setSalesDetails] = useState({
    currency: null,
    orignalPrice: '',
    orignalRateSqft: '',
    profit: '',
    profitCalculate: '',
    listingPrice: '',
    listingPriceRate: '',
    priceinothercontry: '',
    mainSalePrice: '',
    marketAnalysis: '',
    to: '',
    commPaid: '',
    commPaidCalculate: '',
    commSeller: '',
    commSellerCalculate: '',
    sellerTransferFee: '',
    sellerTransferFeeCalcu: '',
    buyerTransferFee: '',
    buyerTransferFeeCalcu: '',
    legalFee: '',
    legalFeeCalcu: '',
    miscFee: '',
    miscFeeCalcu: '',
    comment: '',
    sellerPaidDev: '',
    sellerPaidDevCalcu: '',
    amountDueDev: '',
    amountDueDevCalcu: '',
  });
  const [buyerSummery, setBuyerSummery] = useState({
    sellerTransfer: '',
    developerBalance: '',
    developerBalancePerc: '',
    BuyerCommission: '',
    BuyerCommissionPerc: '',
    DlDTransfer: '',
    DlDTransferPerc: '',
    administrationFee: '',
    administrationFeePerc: '',
    otherFee: '',
    otherFeePerc: '',
    allPrice: '',
    allPricePerc: '',
  });
  const [leaseDetails, setLeaseDetails] = useState({
    dueDate: formattedDate,
    rentPerAnum: '',
    rentByMonth: '',
    rentPerDay: '',
    securityDeposit: '',
    securityDepositPerc: '',
    tenantCommission: '',
    tenantCommissionPerc: '',
    landlordCommission: '',
    landlordCommissionPerc: '',
    maintenanceFee: '',
    rentPayable: '',
    IbanNo: '',
    secDepositPayable: '',
    commissionPayable: '',
    bankName: null,
    accountNo: '',
    fixedCharges: '',
    variableCharges: '',
    installment: '',
  });

  useEffect(() => {
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
    if (!leaseData?.ref_No) {
      toast.warning('No unit selected for update');
      navigate('/Customer/Property/Master/Unit/Listing', { replace: true });
      return;
    }
    fetchDropdownData();
  }, [leaseData?.ref_No, navigate]);
  const fetchDropdownData = async () => {
    if (!leaseData?.ref_No) return;
    try {
      setTableLoading(true);
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'UMReferredBy,UMProperties,UMEnteredBy,UMCostAccounts,UMBedrooms,UMFloors,UMUnitViews,UMUnitTypes,UMUnitCategories,UMImageTypes,UMAreaMeasurements,UMSalesPersons,UMKeyStatus,UMMandate,UMSizeTypes,UMPeriods',
      );
      const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
      const scndparams = new URLSearchParams();
      scndparams.append(
        'dropdownTypes',
        'UMSellerNames,UMReservedFundAccounts,UMAccounts,UMBanks,UMPaymentPlans,UMCountries,UMFurnished,UMCommunities,UMSellers,UMFurniturePlans,UMAgents,UMProjectStatus,UMFurnishing,UMCurrencies',
      );
      const scndRes = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${scndparams.toString()}`);
      const d1 = res?.data?.dropdowns || {};
      const d2 = scndRes?.data?.dropdowns || {};
      setBedRoomList(d1.UMBedrooms);
      setCostAccount(d1.UMCostAccounts);
      setEnteredBy(d1.UMEnteredBy);
      setFloorList(d1.UMFloors);
      setImageView(d1.UMImageTypes);
      setKeyStatusList(d1.UMKeyStatus);
      setManDateList(d1.UMMandate);
      setPeriod(d1.UMPeriods);
      setPropertyList(d1.UMProperties);
      setRefferedBy(d1.UMReferredBy);
      setSizeType(d1.UMSizeTypes);
      setunitCategoryList(d1.UMUnitCategories);
      setunitViewList(d1.UMUnitViews);
      setUnitTypeList(d1.UMUnitTypes);
      setAgent(d2.UMAgents);
      setProjectStatus(d2.UMProjectStatus);
      setcommunityList(d2.UMCommunities);
      setMeasurementList(d2.UMAreaMeasurements);
      setUnitCostList(scndRes?.data?.dropdowns?.UMEnteredBy);
      setLandlordList(d2.UMSellers);
      setSalesPersonList(d2.UMSellers);
      setBankList(d2.UMBanks);
      setPaymentPlan(d2.UMPaymentPlans);
      setCountries(d2.UMCountries);
      setFurnishing(d2.UMFurnishing);
      setCurrency(d2.UMCurrencies);
      setFurniturePlan(d2.UMFurniturePlans);
      setReserveAccList(d2.UMReservedFundAccounts);

      const detailParams = new URLSearchParams();
      detailParams.append('Action', 'GetUnitDetailsByRefNo');
      detailParams.append('UnitRefNo', leaseData.ref_No);
      const unitRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${detailParams.toString()}`);
      const rawResult = unitRes?.data?.result;
      const ud =
        rawResult?.data !== undefined && typeof rawResult?.data === 'object' && !Array.isArray(rawResult.data)
          ? rawResult.data
          : typeof rawResult === 'object' && rawResult !== null
            ? rawResult
            : {};

      const propNo = leaseData?.property_No ?? ud.Property_No ?? ud.property_No;
      if (propNo) {
        const fp = new URLSearchParams();
        fp.append('Action', 'GetUnitfeatuersByPropertyNo');
        fp.append('PropertyNo', String(propNo));
        const fRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${fp.toString()}`);
        setFeaturesList(fRes?.data?.result?.data || []);
      } else {
        setFeaturesList([]);
      }

      const findOpt = (arr, text) => {
        const t = text !== undefined && text !== null ? String(text).trim() : '';
        if (!t || !arr?.length) return null;
        const row = arr.find((x) => String(x?.text ?? '').trim() === t || String(x?.value ?? '').trim() === t);
        return row ? { value: row, label: row.text } : { label: t, value: { text: t, value: t } };
      };
      const pick = (...vals) => {
        for (const v of vals) {
          if (v !== undefined && v !== null && String(v).trim() !== '') return v;
        }
        return '';
      };
      const parseApiDate = (val) => {
        if (!val) return '';
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? '' : d;
      };

      let cityOpts = [];
      const countryLabel = String(pick(ud.Country, ud.country) || '').trim();
      if (countryLabel && d2.UMCountries?.length) {
        const countryRow = d2.UMCountries.find((c) => c.text === countryLabel);
        if (countryRow) {
          const cityParams = new URLSearchParams();
          cityParams.append('DropdownFor', 'UMCitiesByCountry');
          cityParams.append('CascadValue', countryRow.text);
          const cityRes = await apiService.getApiParamater('GET_UNIT_CASCAD', `?${cityParams.toString()}`);
          cityOpts = cityRes?.data?.items || [];
        }
      }
      setCityList(cityOpts);

      const propRow = d1.UMProperties?.find((p) => String(p.value) === String(propNo) || String(p.text) === String(leaseData?.property_Name));
      const property = propRow ? { value: propRow, label: propRow.text } : null;

      setUnitAudit({
        createdBy: String(pick(ud.Created_By, ud.createdBy, '0')),
        createdOn: parseApiDate(ud.Created_On || ud.createdOn) || today,
      });

      setTransectionData((prev) => ({
        ...prev,
        refNo: String(pick(leaseData.ref_No, ud.Ref_No)),
        unitNo: String(pick(leaseData.unit_No, ud.Unit_No)),
        unitClass: String(pick(leaseData.unit_Class, ud.Unit_Class)),
        property,
        country: findOpt(d2.UMCountries, pick(ud.Country, ud.country)),
        city: findOpt(cityOpts, pick(ud.City, ud.city)),
        community: findOpt(d2.UMCommunities, pick(ud.Community, ud.community_Name)),
        unitType: findOpt(d1.UMUnitTypes, pick(leaseData.unit_Type, ud.Unit_Type)),
        unitCategory: findOpt(d1.UMUnitCategories, pick(leaseData.unit_Category, ud.Unit_Category)),
        unitView: findOpt(d1.UMUnitViews, pick(leaseData.unit_View, ud.Unit_View)),
        floor: findOpt(d1.UMFloors, pick(leaseData.floor, ud.Floor)),
        bedRooms: findOpt(d1.UMBedrooms, pick(leaseData.bedrooms, ud.Bedrooms, ud.bedrooms)),
        totalArea: String(pick(leaseData.total_Area, ud.Total_Area, prev.totalArea)),
        unitRate: String(pick(leaseData.sqft_Rate, ud.Sqft_Rate, prev.unitRate)),
        remarks: String(pick(ud.Remarks, leaseData.remarks, prev.remarks)),
        block: String(pick(ud.Block, prev.block)),
        bathRoom: String(pick(ud.Bathrooms, ud.bathrooms, prev.bathRoom)),
        balcony: String(pick(ud.Balcony, prev.balcony)),
        terraceArea: String(pick(ud.Terrace, ud.terrace, prev.terraceArea)),
        livingarea: String(pick(ud.LivingRooms, ud.livingRooms, prev.livingarea)),
        parking: String(pick(leaseData.parking, ud.Parking, prev.parking)),
        parkingPrice: String(pick(leaseData.parking_Price, ud.Parking_Price, prev.parkingPrice)),
        sector: String(pick(ud.Sector, prev.sector)),
        municipltyNo: String(pick(ud.Municipality_No, prev.municipltyNo)),
        saller: findOpt(d2.UMSellers, pick(ud.Seller_Name, ud.seller_Name)),
        landlordId: findOpt(d2.UMSellers, pick(ud.Seller_Id, ud.seller_Id)),
        contactPerson: String(pick(ud.Broker_Name, prev.contactPerson)),
      }));

      setUnitDetails((prev) => ({
        ...prev,
        unitModel: String(pick(ud.Unit_Model, prev.unitModel)),
        unitStyle: String(pick(ud.Unit_Style, prev.unitStyle)),
        streetNo: String(pick(ud.Street_No, prev.streetNo)),
        storeRoom: String(pick(ud.StoreRooms, leaseData.storeRooms, prev.storeRoom)),
        plotNO: String(pick(ud.Plot_No, leaseData.plot_No, prev.plotNO)),
        plotSize: String(pick(ud.Plot_Size, leaseData.plot_Size, prev.plotSize)),
        serviceCharge: String(pick(ud.ServiceCharge, prev.serviceCharge)),
        mandate: findOpt(d1.UMMandate, pick(ud.Mandate, prev.mandate?.label)),
        status: findOpt(d2.UMProjectStatus, pick(ud.Status, leaseData.status, prev.status?.label)),
        paymentPlan: findOpt(d2.UMPaymentPlans, pick(ud.Payment_Plan, prev.paymentPlan?.label)),
        agent: findOpt(d2.UMAgents, pick(ud.Broker_Name, prev.agent?.label)),
        statusKey: findOpt(d1.UMKeyStatus, pick(ud.Key_Status, prev.statusKey?.label)),
        costAccount: findOpt(d1.UMCostAccounts, pick(ud.Cost_Account, prev.costAccount?.label)),
        furnishing: findOpt(d2.UMFurnishing, pick(ud.Furnishing, prev.furnishing?.label)),
        refferedBy: findOpt(d1.UMReferredBy, pick(ud.Refered_By, ud.refered_By, prev.refferedBy?.label)),
        enteredBy: findOpt(d1.UMEnteredBy, pick(ud.Entered_By, prev.enteredBy?.label)),
        furniturePlan: findOpt(d2.UMFurniturePlans, pick(ud.Furniture_Plan, prev.furniturePlan?.label)),
        reservedAccCode: findOpt(d2.UMReservedFundAccounts, pick(ud.Reserved_Account, prev.reservedAccCode?.label)),
        completionDate: parseApiDate(ud.completion_Date) || prev.completionDate,
        expiryDate: parseApiDate(ud.LeaseExpiry ?? ud.leaseExpiry) || prev.expiryDate,
        reffferedDate: parseApiDate(ud.refered_On) || prev.reffferedDate,
        enteredDate: parseApiDate(ud.Entered_On) || prev.enteredDate,
        leased: Boolean(ud.Leased ?? leaseData.leased ?? prev.leased),
        occupied: Boolean(ud.OwnerOccupied ?? prev.occupied),
        propertyRegistered: Boolean(ud.PropertyRegistered ?? prev.propertyRegistered),
      }));

      setSalesDetails((prev) => ({
        ...prev,
        listingPrice: String(pick(ud.ListingPrice, ud.All_In_Price, leaseData.all_In_Price, prev.listingPrice, '0')),
        currency: findOpt(d2.UMCurrencies, pick(ud.Currency, prev.currency?.label)),
        commSeller: String(pick(ud.Seller_Commission, prev.commSeller)),
        commSellerCalculate: String(pick(ud.Seller_Commission_Percent, prev.commSellerCalculate)),
        commPaid: String(pick(ud.Buyer_Commission, prev.commPaid)),
        commPaidCalculate: String(pick(ud.Buyer_Commission_Percent, prev.commPaidCalculate)),
        sellerTransferFee: String(pick(ud.Seller_TransferFee, prev.sellerTransferFee)),
        sellerTransferFeeCalcu: String(pick(ud.Seller_TransferFee_Percent, prev.sellerTransferFeeCalcu)),
        buyerTransferFee: String(pick(ud.Buyer_TransferFee, prev.buyerTransferFee)),
        buyerTransferFeeCalcu: String(pick(ud.Buyer_TransferFee_Percent, prev.buyerTransferFeeCalcu)),
        sellerPaidDev: String(pick(ud.Seller_Paid, prev.sellerPaidDev)),
        sellerPaidDevCalcu: String(pick(ud.Seller_Paid_Percent, prev.sellerPaidDevCalcu)),
        amountDueDev: String(pick(ud.Developer_Due, prev.amountDueDev)),
        amountDueDevCalcu: String(pick(ud.Developer_Due_Percent, prev.amountDueDevCalcu)),
      }));

      setLeaseDetails((prev) => ({
        ...prev,
        rentPerAnum: String(pick(leaseData.rent_Per_Annum, ud.Rent_Per_Annum, prev.rentPerAnum)),
        rentByMonth: String(pick(ud.Rent_Per_Month, prev.rentByMonth)),
        rentPerDay: String(pick(ud.Rent_Per_Day, prev.rentPerDay)),
        securityDeposit: String(pick(ud.Security_Deposit, prev.securityDeposit)),
        tenantCommission: String(pick(ud.Tenant_Commission, prev.tenantCommission)),
        landlordCommission: String(pick(ud.Landlord_Commission, prev.landlordCommission)),
        maintenanceFee: String(pick(ud.Maintenance_Fee, prev.maintenanceFee)),
        installment: String(pick(ud.Installments, prev.installment)),
        bankName: findOpt(d2.UMBanks, pick(ud.RentBankName, prev.bankName?.label)),
        accountNo: String(pick(ud.RentBankAcNo, prev.accountNo)),
        rentPayable: String(pick(ud.RentPayableTo, prev.rentPayable)),
        secDepositPayable: String(pick(ud.SecDepPayableTo, prev.secDepositPayable)),
        commissionPayable: String(pick(ud.ComPayableTo, prev.commissionPayable)),
      }));

      setBuyerSummery((prev) => ({
        ...prev,
        administrationFee: String(pick(ud.Admin_Fees, prev.administrationFee)),
        administrationFeePerc: String(pick(ud.Admin_Fees_Percent, prev.administrationFeePerc)),
        otherFee: String(pick(ud.Other_Fees, prev.otherFee)),
        otherFeePerc: String(pick(ud.Other_Fees_Percent, prev.otherFeePerc)),
      }));

      const fileparams = new URLSearchParams();
      fileparams.append('refNo', String(leaseData.ref_No));
      fileparams.append('fileCategory', 'Images');
      const imgRes = await apiService.getApiParamater('GET_FILE', `?${fileparams.toString()}`);
      if (imgRes?.data?.result?.length) {
        const apiFiles = imgRes.data.result.map((item) => ({
          id: Date.now() + Math.random(),
          file: null,
          fileName: item.fileName,
          remarks: '',
          filePath: item?.filePath,
          isNew: false,
          fullUrl: item.fullUrl,
        }));
        setAttachments([...apiFiles, createEmptyRow()]);
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
      toast.error('Could not load unit for editing');
    } finally {
      setTableLoading(false);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    window.history.back();
  };

  const additionalDataUpload = async (data, refNo) => {
    const unitFeatures = featuresList?.map((item) => ({
      status: item?.DescType || '0',
      description: item?.Description || '0',
      value: item?.Value,
      cnt: parseFloat(item?.Cnt) || 0,
      amount: parseFloat(item?.Amount) || 0,
      isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
    }));
    const image = data?.map((item) => ({
      record_Id: 0,
      image_Description: item?.originalFileName || '0',
      image_Filename: item?.fileName || '0',
      isDefault: true,
      folder: item?.filePath || '0',
      url: item?.fullUrl || '0',
      isAdded: true,
      isUpdated: false,
      isDeleted: false,
    }));
    const body = {
      refNo: refNo || '0',
      unitFeatures,
      unitImages: image,
      unitPayables: [{ description: '0', value: true, landlord: true, tenant: true }],
      unitYearlyRents: [
        {
          year: 0,
          rentPerSqftRest: 0,
          rentPerSqftKitchen: 0,
          rentPerSqftTerrace: 0,
          totalRent: 0,
          scPerSqftRest: 0,
          scPerSqftKitchen: 0,
          scPerSqftTerrace: 0,
          totalServiceCharge: 0,
          chilledWaterPerSqftRest: 0,
          chilledWaterPerSqftKitchen: 0,
          chilledWaterPerSqftTerrace: 0,
          totalChilledWaterCharge: 0,
        },
      ],
      unitFixedCharges: [{ description: '0', amount: 0 }],
    };
    await apiService.post('POST_UNIT_ADDITIONAL', body);
  };

  const handleUpload = async (ref_No) => {
    const formData = new FormData();
    const token = localStorage.getItem('Token');
    const db = localStorage.getItem('DataBase');
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);
    if (!validFiles.length) return;
    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });
    formData.append('refNo', ref_No);
    formData.append('fileCategory', 'Images');
    const response = await axios.post('https://lease.api.apps.rabahrain.com/api/FileUpload/unit-files', formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
    if (response?.data?.result) {
      await additionalDataUpload(response.data.result, ref_No);
    }
  };

  const handleSave = async () => {
    try {
      setloader(true);
      // Edit flow: do not block save on client validation; API accepts defaults (e.g. "0") for optional fields.

      const completionDateIso = (() => {
        const c = unitDetails?.completionDate;
        if (!c) return today.toISOString();
        if (c instanceof Date && !Number.isNaN(c.getTime())) return c.toISOString();
        const d = new Date(c);
        return Number.isNaN(d.getTime()) ? today.toISOString() : d.toISOString();
      })();

      const unitFeatures = featuresList?.map((item, index) => {
        return {
          status: item?.DescType || '0',
          description: item?.Description || '0',
          value: item?.Value,
          cnt: parseFloat(item?.Cnt) || 0,
          amount: parseFloat(item?.Amount) || 0,
          isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
        };
      });
      const body = {
        unitMasterMain: {
          unitMaster: {
            ref_No: transectionData?.refNo || '0',
            property_No: transectionData?.property?.value?.value || '0',
            property_Name: transectionData?.property?.label || '0',
            unit_No: transectionData?.unitNo || '0',
            rerA_STR_No: '0',
            street_No: unitDetails?.streetNo || '0',
            street_Name: '0',
            unit_Type: transectionData?.unitType?.label || '0',
            unit_Category: transectionData?.unitCategory?.label || '0',
            unit_Style: unitDetails?.unitStyle || '0',
            unit_Model: unitDetails?.unitModel || '0',
            unit_Zone: '0',
            plot_No: unitDetails?.plotNO || '0',
            plot_Size: unitDetails?.plotSize || '0',
            block: transectionData?.block || '0',
            floor: transectionData?.floor?.label || '0',
            unit_View: transectionData?.unitView?.label || '0',
            completion_Date: completionDateIso,
            unit_Class: transectionData?.unitClass || '0',
            livingRooms: transectionData?.livingarea || '0',
            bedrooms: transectionData?.bedRooms?.label || '0',
            storeRooms: unitDetails?.storeRoom || '0',
            parking: transectionData?.parking || '0',
            facilities: '0',
            status: unitDetails?.status?.label || '0',
            payment_Plan: unitDetails?.paymentPlan?.label || '0',
            broker_Name: unitDetails?.agent?.label || '0',
            seller_Id: transectionData?.landlordId?.label || '0',
            seller_Name: transectionData?.saller?.label || '0',
            adv_Listing: true,
            adv_OpenHouse: true,
            adv_Remarks1: '0',
            adv_Remarks2: '0',
            adv_Remarks3: '0',
            remarks: transectionData?.remarks || '0',
            internalRemarks: transectionData?.remarks || '0',
            otherSpace1: '0',
            bathrooms: transectionData?.bathRoom || '0',
            balcony: transectionData?.balcony || '0',
            terrace: transectionData?.terraceArea || '0',
            total_Area: parseFloat(transectionData?.totalArea) || 0,
            measured_Area: 0,
            sqft_Rate: parseFloat(transectionData?.unitRate || 0),
            purchase_Value: 0,
            total_Value: 0,
            measured_Value: 0,
            roundOff_Value: 0,
            parking_Price: parseFloat(transectionData?.parkingPrice) || 0,
            all_In_Price: 0,
            premium: 0,
            premium_Percent: 0,
            seller_Commission: parseFloat(salesDetails?.commSeller) || 0,
            seller_Commission_Percent: parseFloat(salesDetails?.commSellerCalculate) || 0,
            buyer_Commission: parseFloat(salesDetails?.commPaid) || 0,
            buyer_Commission_Percent: parseFloat(salesDetails?.commPaidCalculate) || 0,
            seller_TransferFee: parseFloat(salesDetails?.sellerTransferFee) || 0,
            seller_TransferFee_Percent: parseFloat(salesDetails?.sellerTransferFeeCalcu) || 0,
            buyer_TransferFee: parseFloat(salesDetails?.buyerTransferFee) || 0,
            buyer_TransferFee_Percent: parseFloat(salesDetails?.buyerTransferFeeCalcu) || 0,
            admin_Fees: parseFloat(buyerSummery?.administrationFee) || 0,
            admin_Fees_Percent: parseFloat(buyerSummery?.administrationFeePerc) || 0,
            other_Fees: parseFloat(buyerSummery?.otherFee) || 0,
            other_Fees_Percent: parseFloat(buyerSummery?.otherFeePerc) || 0,
            other_Fees_Remarks: '0',
            seller_Paid: parseFloat(salesDetails?.sellerPaidDev) || 0,
            seller_Paid_Percent: parseFloat(salesDetails?.sellerPaidDevCalcu) || 0,
            developer_Due: parseFloat(salesDetails?.amountDueDev) || 0,
            developer_Due_Percent: parseFloat(salesDetails?.amountDueDevCalcu) || 0,
            rent_Per_Annum: parseFloat(leaseDetails?.rentPerAnum) || 0,
            short_Term_Rent: 0,
            short_Term_Period: '0',
            rent_Per_Day: parseFloat(leaseDetails?.rentPerDay) || 0,
            security_Deposit: parseFloat(leaseDetails?.securityDeposit) || 0,
            advance_Deposit: 0,
            tenant_Commission: parseFloat(leaseDetails?.tenantCommission) || 0,
            landlord_Commission: parseFloat(leaseDetails?.landlordCommission) || 0,
            maintenance_Fee: parseFloat(leaseDetails?.maintenanceFee) || 0,
            negotiable: true,
            currency: salesDetails?.currency?.label || '0',
            cmA_Range1: 0,
            cmA_Range2: 0,
            installments: parseFloat(leaseDetails?.installment) || 0,
            rentPayableTo: leaseDetails?.rentPayable || '0',
            rentBankName: leaseDetails?.bankName?.label || '0',
            rentBankAcNo: leaseDetails?.accountNo || '0',
            secDepPayableTo: leaseDetails?.secDepositPayable || '0',
            comPayableTo: leaseDetails?.commissionPayable || '0',
            key_Status: unitDetails?.statusKey?.label || '0',
            publishStatus: true,
            serviceCharge: unitDetails?.serviceCharge || '0',
            ownerOccupied: unitDetails?.occupied ?? true,
            leased: unitDetails?.leased || false,
            leaseAmount: 0,
            leaseExpiry: unitDetails?.expiryDate,
            mandate: unitDetails?.mandate?.label || '0',
            financeCompany: '0',
            mortgaged: true,
            mortgageCompany: '0',
            propertyRegistered: unitDetails?.propertyRegistered ?? true,
            portfolio: 0,
            portfolioManager: '0',
            propertyType: '0',
            factor: 0,
            common: 0,
            cp: 0,
            effeciency: '0',
            listingPriceUSD: 0,
            monthlyIncome: '0',
            annualIncome: '0',
            exp9: '0',
            exp10: '0',
            refered_By: unitDetails?.refferedBy?.label || '0',
            refered_On: unitDetails?.reffferedDate,
            createdBy: unitAudit?.createdBy || userName || '0',
            createdOn: unitAudit?.createdOn || today,
            modifiedBy: userName || '0',
            modifiedOn: today,
          },
          unitFeatures: unitFeatures,
          unitImages: [
            {
              record_Id: 0,
              image_Description: '0',
              image_Filename: '0',
              isDefault: true,
              folder: '0',
              url: '0',
              isAdded: false,
              isUpdated: false,
              isDeleted: false,
            },
          ],
          unitPayables: [
            {
              description: '0',
              value: true,
              landlord: true,
              tenant: true,
            },
          ],
          unitYearlyRents: [
            {
              year: 0,
              rentPerSqftRest: 0,
              rentPerSqftKitchen: 0,
              rentPerSqftTerrace: 0,
              totalRent: 0,
              scPerSqftRest: 0,
              scPerSqftKitchen: 0,
              scPerSqftTerrace: 0,
              totalServiceCharge: 0,
              chilledWaterPerSqftRest: 0,
              chilledWaterPerSqftKitchen: 0,
              chilledWaterPerSqftTerrace: 0,
              totalChilledWaterCharge: 0,
            },
          ],
          unitFixedCharges: [
            {
              description: '0',
              amount: 0,
            },
          ],
        },
      };
      const putRes = await apiService.put('UPDATE_UNIT', body);
      if (putRes?.data?.statusCode === 200 || putRes?.data?.statusCode === 201) {
        const refNo = transectionData?.refNo || leaseData?.ref_No;
        await handleUpload(refNo);
        toast.success(putRes?.data?.message);
        setloader(false);
        navigate('/Customer/Property/Master/Unit/Listing');
      } else {
        toast.warning(`${putRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  return (
    <div className="p-3">
      <div className="border-box2 p-2 d-flex justify-content-between" style={{ borderRadius: '8px' }}>
        <div className="">
          <h6>Update Unit Master</h6>
        </div>
        <div className="d-flex gap-3">
          {loading === true ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">Save</div>
            </div>
          )}
          <div className="mainbtnSecondary flex-end gap-2" onClick={handleBackClick}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Unit Master
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            Unit Details
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            Unit Features
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            Sales Details
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 4 ? 'sideActive' : ''}`} onClick={() => handleTabClick(4)}>
            Buyer Summery
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 5 ? 'sideActive' : ''}`} onClick={() => handleTabClick(5)}>
            Lease Details
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 6 ? 'sideActive' : ''}`} onClick={() => handleTabClick(6)}>
            Advertisement
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 7 ? 'sideActive' : ''}`} onClick={() => handleTabClick(7)}>
            Imagess
          </div>
        </div>
      </div>
      {/* Lease Details */}
      {gridVisibility[0] && (
        <MasterDetails
          tableLoading={tableLoading}
          countriesList={countriesList}
          salersList={salersList}
          setCityList={setCityList}
          setTransectionData={setTransectionData}
          propertyList={propertyList}
          cityList={cityList}
          setFeaturesList={setFeaturesList}
          transectionData={transectionData}
          landlordList={landlordList}
          communityList={communityList}
          unitTypeList={unitTypeList}
          unitViewList={unitViewList}
          floorList={floorList}
          unitCategoryList={unitCategoryList}
          setcommunityList={setcommunityList}
          setunitCategoryList={setunitCategoryList}
          bedRoomList={bedRoomList}
        />
      )}
      {gridVisibility[1] && (
        <UnitDetails
          tableLoading={tableLoading}
          manDateList={manDateList}
          reserveAccList={reserveAccList}
          agent={agent}
          setTransectionData={setUnitDetails}
          keyStatusList={keyStatusList}
          unitCostList={unitCostList}
          paymentPlan={paymentPlan}
          furnishing={furnishing}
          transectionData={unitDetails}
          projectStatus={projectStatus}
          costAccount={costAccount}
          refferedBy={refferedBy}
          enteredBy={enteredBy}
          furniturePlan={furniturePlan}
        />
      )}
      {gridVisibility[2] && <UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />}
      {gridVisibility[3] && (
        <SalesDetails tableLoading={tableLoading} setTransectionData={setSalesDetails} transectionData={salesDetails} countriesList={countriesList} />
      )}
      {gridVisibility[4] && <BuyerSummery tableLoading={tableLoading} setTransectionData={setBuyerSummery} transectionData={buyerSummery} />}
      {gridVisibility[5] && (
        <LeaseDetails tableLoading={tableLoading} setTransectionData={setLeaseDetails} transectionData={leaseDetails} bankList={bankList} />
      )}
      {gridVisibility[7] && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />}
    </div>
  );
};
export default UpdateUnitMaster;
